import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

/**
 * 总共有三种状态:
 * 0 不选中
 * 1 选中
 * 2 审核中
 */
type State = 0 | 1 | 2;

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'icc-state',
    styleUrls: ['./icc-state.component.less'],
    template: `
        <div class="mask" [attr.state]="state">
            <a
                class="targger"
                (click)="changeState()"
                [ngStyle]="{ left: offsetArr[0] + 'px', right: offsetArr[1] + 'px', top: offsetArr[2] + 'px', bottom: offsetArr[3] + 'px' }"
            ></a>
        </div>
        <ng-content class="content"></ng-content>
    `,
})
export class IccStateComponent implements OnInit {
    // 状态
    @Input() state: State = 1;
    // 触发器偏移参数 = [left,right,top,bottom]
    @Input() offsetArr = [0, 0, 0, 0];
    // 状态改变的回调(返回是否选中)
    @Output() stateChange = new EventEmitter<boolean>();
    constructor() {}

    ngOnInit() {}

    // 改变状态
    changeState() {
        switch (this.state) {
            case 2:
                break;
            case 1:
                this.state = 0;
                this.stateChange.next(false);
                break;
            case 0:
                this.state = 1;
                this.stateChange.next(true);
                break;
            default:
                break;
        }
    }
}
